var _style, _defs, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgImage3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 395 233",
    style: {
      enableBackground: "new 0 0 395 233"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000092433131411274330010000015783628834116875937_);}\n\t.st1{display:none;fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-opacity:0.1;}\n\t.st2{fill:url(#SVGID_00000147904122615225617340000010730912663005743027_);}\n\t.st3{fill:#C6C6C6;}\n\t.st4{opacity:0.5;}\n\t.st5{fill:url(#SVGID_00000008866887423655138650000018105980943880007564_);}\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:0.676;stroke-opacity:0.1;}\n\t.st7{fill:none;stroke:#D8D5D1;stroke-width:1.051;stroke-linecap:round;stroke-linejoin:round;}\n\t.st8{fill:url(#SVGID_00000075122513423594290840000009192382113413072783_);}\n\t.st9{fill:url(#SVGID_00000056421071427284157300000007805104537446265728_);}\n\t.st10{fill:url(#SVGID_00000057132531624883478790000013881738849271373960_);}\n\t.st11{fill:url(#SVGID_00000017478256916231363650000006837637997264182955_);}\n\t.st12{fill:#D8D5D1;}\n\t.st13{fill:url(#SVGID_00000083777221547717122970000015967823777601134746_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M16.3,0h362c8.8,0,16,7.2,16,16v201c0,8.8-7.2,16-16,16h-362c-8.8,0-16-7.2-16-16V16C0.3,7.2,7.5,0,16.3,0z "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000102507222656260840500000008639099335914411946_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000102507222656260840500000008639099335914411946_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.5,60.8L195.5,60.8c30.2,0,54.8,24.5,54.8,54.8l0,0c0,30.2-24.5,54.8-54.8,54.8l0,0 c-30.2,0-54.8-24.5-54.8-54.8l0,0C140.8,85.3,165.3,60.8,195.5,60.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169515619524584114590000014716329739783808658_",
    gradientUnits: "userSpaceOnUse",
    x1: 271.8112,
    y1: 136.2295,
    x2: 123.1884,
    y2: 96.7704
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010208"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#161616"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169515619524584114590000014716329739783808658_)"
    },
    d: "M224.3,173.4h-53.6 c-16.6,0-30.1-13.5-30.1-30.1V89.7c0-16.6,13.5-30.1,30.1-30.1h53.6c16.6,0,30.1,13.5,30.1,30.1v53.6 C254.4,159.9,240.9,173.4,224.3,173.4z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M175.7,100c0.4,0,0.7-0.3,0.7-0.7v-3.6c0-0.4-0.3-0.7-0.7-0.7s-0.7,0.3-0.7,0.7v3.6 C174.9,99.7,175.3,100,175.7,100z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M172,100c0.4,0,0.7-0.3,0.7-0.7v-7.3c0-0.4-0.3-0.7-0.7-0.7c-0.4,0-0.7,0.3-0.7,0.7v7.3 C171.2,99.6,171.5,100,172,100C172,100,172,100,172,100z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M168.3,100c0.4,0,0.7-0.3,0.7-0.7v-4.9c0-0.4-0.3-0.7-0.7-0.7s-0.7,0.3-0.7,0.7v4.9 C167.5,99.6,167.9,100,168.3,100C168.3,100,168.3,100,168.3,100z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M221.2,102.3c0.4,0,0.7-0.3,0.7-0.7v-3.7c0-0.4-0.3-0.7-0.7-0.7c-0.4,0-0.7,0.3-0.7,0.7v3.6 C220.5,101.9,220.8,102.2,221.2,102.3C221.2,102.3,221.2,102.3,221.2,102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M224.4,93.5c-0.4,0-0.7,0.3-0.7,0.7v7.3c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7v-7.3 C225.2,93.8,224.8,93.5,224.4,93.5C224.4,93.5,224.4,93.5,224.4,93.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M227.6,95.9c-0.4,0-0.7,0.3-0.7,0.7v4.9c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7v-4.9 C228.3,96.2,228,95.9,227.6,95.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M186.6,132.3c0.4-0.1,0.6-0.5,0.5-0.9c-0.1-0.4-0.5-0.6-0.9-0.5l0,0c-2.5,0.6-3.7,1.5-3.7,2.6 c0,2.9,8.8,3.6,13.9,3.6c5.2,0,13.9-0.8,13.9-3.6c0-1.1-1.2-1.9-3.7-2.6c-0.4-0.1-0.8,0.1-0.9,0.5c-0.1,0.4,0.1,0.8,0.5,0.9 c0,0,0,0,0,0c2.3,0.6,2.6,1.1,2.6,1.1c-0.3,0.8-4.8,2.2-12.5,2.2s-12.2-1.4-12.5-2.1C184,133.4,184.2,132.9,186.6,132.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M216.8,130.8c-0.4-0.1-0.8,0.1-0.9,0.5c-0.1,0.4,0.1,0.8,0.5,0.9c0,0,0,0,0,0c4.2,1.1,5.8,2.3,5.8,3 c0,2.1-9.8,5-25.7,5s-25.7-2.9-25.7-5c0-0.7,1.5-1.9,5.8-3c0.4-0.1,0.6-0.5,0.5-0.9c-0.1-0.4-0.5-0.6-0.9-0.5 c-4.6,1.2-6.9,2.7-6.9,4.4c0,4.3,13.7,6.5,27.2,6.5c13.5,0,27.2-2.2,27.2-6.5C223.6,133.5,221.3,132,216.8,130.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M177,120.7c-1.8,0-3.3,1.5-3.3,3.3s1.5,3.3,3.3,3.3s3.3-1.5,3.3-3.3c0,0,0,0,0,0 C180.2,122.1,178.8,120.7,177,120.7z M177,125.7c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8 C178.8,124.9,178,125.7,177,125.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M216.1,120.7c-1.8,0-3.3,1.5-3.3,3.3s1.5,3.3,3.3,3.3s3.3-1.5,3.3-3.3c0,0,0,0,0,0 C219.3,122.1,217.9,120.7,216.1,120.7z M216.1,125.7c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8c1,0,1.8,0.8,1.8,1.8 C217.9,124.9,217.1,125.7,216.1,125.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M207.9,107.9c-1-1-2.4-1.5-3.8-1.5h-10.2c-2,0-3.9,1.1-4.8,2.9l-1.4,2.7c-0.2,0.4-0.1,0.8,0.3,1 c0.1,0.1,0.2,0.1,0.4,0.1h23.1c0.4,0,0.7-0.3,0.7-0.7c0-0.2-0.1-0.4-0.2-0.5L207.9,107.9z M189.6,111.6l0.8-1.6 c0.7-1.3,2-2.1,3.5-2.1h10.2c1,0,2,0.4,2.8,1.1l2.7,2.6H189.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M224.4,111.3H217c-1.1-2-2.6-3.7-4.4-5.1l4.3-4.3h1.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.7-0.7-0.7h-1.8 c-0.2,0-0.4,0.1-0.5,0.2l-4.7,4.7c-2.6-1.6-5.6-2.4-8.6-2.4h-8.9c-0.6,0-1.3,0.1-1.9,0.2l-5.1-5.1c-0.1-0.1-0.3-0.2-0.5-0.2 h-6.9c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7h6.6l4.3,4.3c-1.9,0.8-3.6,2.1-4.6,3.9l-1.9,3.2c-7,0.9-12.7,3-15.1,4.7 c-1.3,0.9-2.1,2.4-2.1,4.1v2.2c0,2.3,1.9,4.2,4.2,4.2h0.7c1,3,4.3,4.6,7.3,3.6c1.7-0.6,3-1.9,3.6-3.6h28.2c1,3,4.3,4.6,7.3,3.6 c1.7-0.6,3.1-2,3.6-3.8c2.1-0.6,3.5-2.6,3.5-4.8V112C225.2,111.6,224.8,111.3,224.4,111.3C224.4,111.3,224.4,111.3,224.4,111.3 z M177,128.2c-2.4,0-4.3-1.9-4.3-4.3s1.9-4.3,4.3-4.3c2.4,0,4.3,1.9,4.3,4.3l0,0C181.3,126.3,179.4,128.2,177,128.2z  M216.1,128.2c-2.4,0-4.3-1.9-4.3-4.3s1.9-4.3,4.3-4.3c2.4,0,4.3,1.9,4.3,4.3v0C220.4,126.3,218.5,128.2,216.1,128.2 L216.1,128.2z M223.7,120.8c0,1.3-0.7,2.5-1.8,3.1c-0.1-3.2-2.7-5.7-5.9-5.7c-3.1,0.1-5.6,2.6-5.7,5.7c0,0.1,0,0.3,0,0.4h-27.6 c0-0.1,0-0.3,0-0.4c-0.1-3.2-2.7-5.7-5.9-5.7c-3.1,0-5.6,2.6-5.7,5.7c0,0.1,0,0.3,0,0.4h-0.4c-1.5,0-2.7-1.2-2.7-2.7v-2.2 c0-1.1,0.6-2.2,1.5-2.8c1.9-1.3,7.4-3.6,14.8-4.4c0.2,0,0.4-0.2,0.5-0.4l2.1-3.5c1.4-2.4,4-3.9,6.8-3.9h8.9 c2.9,0,5.7,0.8,8.1,2.4l0,0c0.1,0.1,0.2,0.1,0.3,0.2c2,1.4,3.6,3.2,4.8,5.3c0.1,0.2,0.4,0.4,0.6,0.4h7.1L223.7,120.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122696203971858676410000001483173990367997614_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.785,
    y1: 143.8064,
    x2: 284.677,
    y2: 128.1134,
    gradientTransform: "matrix(1 0 0 -1 0 234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010208"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#161616"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122696203971858676410000001483173990367997614_)"
    },
    d: "M314.2,73L314.2,73 c13.8,0,25,11.2,25,25l0,0c0,13.8-11.2,25-25,25l0,0c-13.8,0-25-11.2-25-25l0,0C289.2,84.2,300.4,73,314.2,73z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M314.2,73.4L314.2,73.4c13.6,0,24.7,11,24.7,24.7l0,0c0,13.6-11,24.7-24.7,24.7l0,0 c-13.6,0-24.7-11-24.7-24.7l0,0C289.6,84.4,300.6,73.4,314.2,73.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M303.9,87.8l2.1,2.1 M325,87.8l-2.1,2.1 M325,108.8l-2.1-2.1 M303.9,108.8l2.1-2.1 M303.9,102.5h1.6  M310.3,87.8v1.6 M325,94.1h-1.6 M318.7,108.8v-1.6 M320.8,102.5h3.7 M318.7,87.8V92 M303.9,94.1h4.2 M310.3,108.8v-4.2  M313.9,93.6l-4.1,4.1c-0.2,0.2-0.3,0.3-0.4,0.4c0,0.1,0,0.2,0,0.3c0,0.1,0.1,0.2,0.4,0.4l4.1,4.1c0.2,0.2,0.3,0.3,0.4,0.4 c0.1,0,0.2,0,0.3,0c0.1,0,0.2-0.1,0.4-0.4l4.1-4.1c0.2-0.2,0.3-0.3,0.4-0.4c0-0.1,0-0.2,0-0.3c0-0.1-0.1-0.2-0.4-0.4l-4.1-4.1 c-0.2-0.2-0.3-0.3-0.4-0.4c-0.1,0-0.2,0-0.3,0C314.2,93.3,314.1,93.4,313.9,93.6L313.9,93.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034797561578629847710000006637130860980773248_",
    gradientUnits: "userSpaceOnUse",
    x1: 393.8214,
    y1: 209.5499,
    x2: 334.7134,
    y2: 193.8569,
    gradientTransform: "matrix(1 0 0 -1 0 234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010208"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#161616"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034797561578629847710000006637130860980773248_)"
    },
    d: "M364.3,7.3L364.3,7.3 c13.8,0,25,11.2,25,25l0,0c0,13.8-11.2,25-25,25l0,0c-13.8,0-25-11.2-25-25l0,0C339.3,18.5,350.5,7.3,364.3,7.3z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M364.3,7.6L364.3,7.6c13.6,0,24.7,11,24.7,24.7l0,0c0,13.6-11,24.7-24.7,24.7l0,0c-13.6,0-24.7-11-24.7-24.7 l0,0C339.6,18.7,350.6,7.6,364.3,7.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M368.7,38.8l2.1,2.1l4.2-4.2 M375,30.4h-21 M375,32.5v-4c0-1.2,0-1.8-0.2-2.2c-0.2-0.4-0.5-0.7-0.9-0.9 c-0.5-0.2-1-0.2-2.2-0.2h-14.3c-1.2,0-1.8,0-2.2,0.2c-0.4,0.2-0.7,0.5-0.9,0.9c-0.2,0.4-0.2,1-0.2,2.2v8c0,1.2,0,1.8,0.2,2.2 c0.2,0.4,0.5,0.7,0.9,0.9c0.5,0.2,1,0.2,2.2,0.2h7.1"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083080716230397866320000013494092891907665833_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.5909,
    y1: 68.4623,
    x2: 48.4829,
    y2: 52.7693,
    gradientTransform: "matrix(1 0 0 -1 0 234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010208"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#161616"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083080716230397866320000013494092891907665833_)"
    },
    d: "M78,148.4L78,148.4 c13.8,0,25,11.2,25,25l0,0c0,13.8-11.2,25-25,25l0,0c-13.8,0-25-11.2-25-25l0,0C53,159.6,64.2,148.4,78,148.4z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M78,148.7L78,148.7c13.6,0,24.7,11,24.7,24.7l0,0c0,13.6-11,24.7-24.7,24.7h0c-13.6,0-24.7-11-24.7-24.7l0,0 C53.4,159.8,64.4,148.7,78,148.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M70.9,184.1h14.7 M68.3,169.4h20 M76.2,163.1l-2.1,6.3l4.2,11l4.2-11l-2.1-6.3 M78.9,180.3l9.4-10.3 c0.2-0.2,0.3-0.3,0.3-0.4c0-0.1,0-0.2,0-0.3c0-0.1-0.1-0.2-0.3-0.4l-4.5-5.4c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1,0-0.1-0.1-0.2-0.1 c-0.1,0-0.1,0-0.3,0h-9.7c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.2l-4.5,5.4c-0.2,0.2-0.2,0.3-0.3,0.4 c0,0.1,0,0.2,0,0.3c0,0.1,0.1,0.2,0.3,0.4l9.4,10.3c0.2,0.2,0.3,0.4,0.5,0.4c0.1,0,0.2,0,0.3,0C78.6,180.6,78.7,180.5,78.9,180.3 L78.9,180.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075883909848236886490000011395495171833196982_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.4878,
    y1: 175.0538,
    x2: 96.3798,
    y2: 159.3609,
    gradientTransform: "matrix(1 0 0 -1 0 234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010208"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#161616"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075883909848236886490000011395495171833196982_)"
    },
    d: "M125.9,41.8L125.9,41.8 c13.8,0,25,11.2,25,25l0,0c0,13.8-11.2,25-25,25l0,0c-13.8,0-25-11.2-25-25l0,0C100.9,53,112.1,41.8,125.9,41.8z"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M125.9,42.1L125.9,42.1c13.6,0,24.7,11,24.7,24.7l0,0c0,13.6-11,24.7-24.7,24.7h0c-13.6,0-24.7-11-24.7-24.7 l0,0C101.3,53.2,112.3,42.1,125.9,42.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M119.3,57.2l-1.6,2.2c-0.3,0.4-0.5,0.6-0.5,0.8c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.4,0.1,1,0.1h15.6 c0.5,0,0.8,0,1-0.1c0.1-0.1,0.2-0.2,0.2-0.4c0-0.2-0.2-0.4-0.5-0.8l-1.6-2.2 M119.3,57.2c0.2-0.2,0.3-0.4,0.4-0.5 c0.1-0.1,0.2-0.1,0.3-0.2c0.1,0,0.3,0,0.6,0h10.9c0.3,0,0.5,0,0.6,0c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.2,0.4,0.5 M119.3,57.2 l-2,2.6c-0.2,0.3-0.4,0.5-0.5,0.7c-0.1,0.2-0.1,0.3-0.2,0.5c0,0.2,0,0.4,0,0.8v12.3c0,1.2,0,1.8,0.2,2.2c0.2,0.4,0.5,0.7,0.9,0.9 c0.4,0.2,1,0.2,2.2,0.2h12.2c1.2,0,1.8,0,2.2-0.2c0.4-0.2,0.7-0.5,0.9-0.9c0.2-0.4,0.2-1,0.2-2.2V61.8c0-0.4,0-0.6,0-0.8 c0-0.2-0.1-0.3-0.2-0.5c-0.1-0.2-0.2-0.3-0.5-0.7l-2-2.6 M130.4,64.9c0,2.3-1.9,4.2-4.2,4.2c0,0,0,0,0,0c-2.3,0-4.2-1.9-4.2-4.2"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139983423829244307760000006748578704029776820_",
    gradientUnits: "userSpaceOnUse",
    x1: 341.8503,
    y1: 46.3537,
    x2: 282.7423,
    y2: 30.6608,
    gradientTransform: "matrix(1 0 0 -1 0 234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010208"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#161616"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139983423829244307760000006748578704029776820_)"
    },
    d: "M312.3,170.5L312.3,170.5 c13.8,0,25,11.2,25,25l0,0c0,13.8-11.2,25-25,25l0,0c-13.8,0-25-11.2-25-25l0,0C287.3,181.7,298.5,170.5,312.3,170.5z"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M312.3,170.8L312.3,170.8c13.6,0,24.7,11,24.7,24.7l0,0c0,13.6-11,24.7-24.7,24.7l0,0 c-13.6,0-24.7-11-24.7-24.7l0,0C287.6,181.9,298.7,170.8,312.3,170.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M312.3,186.6c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0v-3.1c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3v3.1 C312,186.5,312.1,186.6,312.3,186.6C312.3,186.6,312.3,186.6,312.3,186.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M305,189.9c0.1,0.1,0.3,0.1,0.4,0c0.1-0.1,0.1-0.3,0-0.4l-2.2-2.2c-0.1-0.1-0.3-0.1-0.4,0 c-0.1,0.1-0.1,0.3,0,0.4L305,189.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M302.3,196.4h-3.1c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3c0,0,0,0,0,0h3.1c0.2,0,0.3-0.1,0.3-0.3 C302.6,196.5,302.5,196.4,302.3,196.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M305,203.1l-2.2,2.2c-0.1,0.1-0.1,0.3,0,0.4c0.1,0.1,0.3,0.1,0.4,0l0,0l2.2-2.2c0.1-0.1,0.1-0.3,0-0.4 C305.3,203,305.1,203,305,203.1L305,203.1L305,203.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M319.4,190c0.1,0,0.2,0,0.2-0.1l2.2-2.2c0.1-0.1,0.1-0.3,0-0.4c-0.1-0.1-0.3-0.1-0.4,0l-2.2,2.2 c-0.1,0.1-0.1,0.3,0,0.4C319.2,190,319.3,190,319.4,190L319.4,190z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M325.4,196.4h-3.1c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.1c0.2,0,0.3-0.1,0.3-0.3 C325.7,196.5,325.6,196.4,325.4,196.4C325.4,196.4,325.4,196.4,325.4,196.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M319.6,203.1c-0.1-0.1-0.3-0.1-0.4,0c-0.1,0.1-0.1,0.3,0,0.4l0,0l2.2,2.2c0.1,0.1,0.3,0.1,0.4,0 c0.1-0.1,0.1-0.3,0-0.4L319.6,203.1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M318.1,189.8c-1.4-1.4-3.6-2.1-6.5-2c-0.2,0-0.3,0.1-0.3,0.3v0.6h-0.8c-0.2,0-0.3,0.1-0.3,0.3l-0.2,1.8 c-0.5,0.1-1,0.3-1.5,0.6l-1.4-1.2c-0.1-0.1-0.3-0.1-0.4,0l-1.6,1.6c-0.1,0.1-0.1,0.3,0,0.4l1.2,1.4c-0.3,0.5-0.5,0.9-0.6,1.4 l-1.8,0.2c-0.2,0-0.3,0.1-0.3,0.3v2.2c0,0.2,0.1,0.3,0.3,0.3l1.8,0.2c0.1,0.5,0.3,1,0.6,1.5l-1.2,1.4c-0.1,0.1-0.1,0.3,0,0.4 l1.6,1.6c0.1,0.1,0.3,0.1,0.4,0l1.4-1.1c0.5,0.3,1,0.5,1.5,0.6l0.2,1.8c0,0.2,0.1,0.3,0.3,0.3h0.8v3.6c0,0.2,0.1,0.3,0.3,0.3 c0,0,0,0,0,0h4.3c0.2,0,0.3-0.1,0.3-0.3v-2.7c0,0,0-0.1,0-0.1l0-3.3c0-0.3,0.2-0.6,0.5-0.8c2.2-1.5,3.4-3.6,3.4-5.9 C320.1,192.9,319.4,191,318.1,189.8z M311.3,200.4c-2.1-0.2-3.6-2-3.4-4c0.1-1.8,1.6-3.3,3.4-3.4V200.4z M310.8,204.1l-0.2-1.6 v-0.1c0-0.1-0.1-0.3-0.2-0.3l-0.1,0c-0.6-0.1-1.1-0.4-1.6-0.7c-0.1-0.1-0.2-0.1-0.3,0l-1.4,1.1l-1.2-1.2l1-1.3l0.1-0.1 c0.1-0.1,0.1-0.2,0-0.3c-0.3-0.5-0.5-1.1-0.7-1.6c0-0.1-0.1-0.2-0.2-0.2l-0.2,0l-1.6-0.2v-1.7l1.6-0.2l0.2,0 c0.1,0,0.2-0.1,0.2-0.2c0.1-0.6,0.4-1.1,0.7-1.6c0.1-0.1,0.1-0.2,0-0.3l-1.1-1.4l1.2-1.2l1.3,1l0.1,0.1c0.1,0.1,0.3,0.1,0.4,0 l0,0c0.5-0.3,1.1-0.5,1.6-0.7c0.1,0,0.2-0.2,0.2-0.3l0.2-1.7h0.5v3.1c-2.4,0.2-4.2,2.2-4,4.6c0.2,2.2,1.9,3.9,4,4v3.1 L310.8,204.1z M315.6,208h-3.7v-2.1h3.7V208z M316.3,200.8c-0.5,0.3-0.7,0.8-0.7,1.3l0,3.1h-2.1v-6.6l3.8-3 c0.1-0.1,0.2-0.3,0.1-0.4c-0.1-0.1-0.3-0.2-0.4-0.1l0,0l-3.9,3.1c-0.1,0.1-0.1,0.1-0.1,0.2v6.8h-0.9v-16.9h0.1 c2.5,0,4.4,0.6,5.7,1.8c1.2,1.2,1.8,2.9,1.8,5.2C319.5,197.5,318.3,199.4,316.3,200.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041293475369375534810000007744537036525819835_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.8369,
    y1: 220.2859,
    x2: -9.2711,
    y2: 204.5929,
    gradientTransform: "matrix(1 0 0 -1 0 234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010208"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#161616"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041293475369375534810000007744537036525819835_)"
    },
    d: "M20.3-3.4L20.3-3.4 c13.8,0,25,11.2,25,25l0,0c0,13.8-11.2,25-25,25l0,0c-13.8,0-25-11.2-25-25l0,0C-4.7,7.8,6.5-3.4,20.3-3.4z"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M20.3-3.1L20.3-3.1c13.6,0,24.7,11,24.7,24.7l0,0c0,13.6-11,24.7-24.7,24.7l0,0c-13.6,0-24.7-11-24.7-24.7 l0,0C-4.4,7.9,6.7-3.1,20.3-3.1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M12.1,20.7l8.4,2.1l8.4-2.1 M12.1,20.7l8.4-9.5 M12.1,20.7l8.4-2.1 M28.9,20.7l-8.4-9.5 M28.9,20.7l-8.4-2.1  M20.5,11.3v7.4 M13.7,24.9l6.8,7.4l6.8-7.4l-6.8,1.6L13.7,24.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgImage3);
export default __webpack_public_path__ + "static/media/BgImage3.2a7c443a4477ee6ce2abda36212f5105.svg";
export { ForwardRef as ReactComponent };